export const categories = [
  {
    id: 'shoes',
    name: 'Shoes',
    namePt: 'Sapatos',
    nameDe: 'Schuhe',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=A%20pair%20of%20premium%20white%20leather%20sneakers%20with%20subtle%20cream%20and%20sage%20green%20accents%20resting%20on%20a%20warm%20terracotta%20clay%20studio%20surface%2C%20soft%20directional%20side%20lighting%20creating%20gentle%20shadows%2C%20editorial%20product%20photography%20with%20a%20clean%20minimalist%20composition%20and%20plenty%20of%20negative%20space&width=400&height=300&seq=cat-shoes&orientation=landscape&nocache=true',
  },
  {
    id: 'hoodies',
    name: 'Hoodies / Sweaters',
    namePt: 'Moletom / Suéteres',
    nameDe: 'Hoodies / Pullover',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=A%20neatly%20folded%20oatmeal%20beige%20oversized%20hoodie%20placed%20on%20a%20soft%20dove%20gray%20linen%20background%20with%20a%20single%20eucalyptus%20sprig%20beside%20it%2C%20warm%20natural%20window%20light%2C%20calm%20Scandinavian%20aesthetic%2C%20high-end%20apparel%20catalog%20photography%20with%20soft%20focus%20and%20gentle%20texture&width=400&height=300&seq=cat-hoodies&orientation=landscape&nocache=true',
  },
  {
    id: 'tshirts',
    name: 'T-Shirts',
    namePt: 'Camisetas',
    nameDe: 'T-Shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=A%20colorful%20flat%20lay%20of%20three%20folded%20premium%20cotton%20t-shirts%20in%20mustard%2C%20blush%20pink%20and%20sage%20green%20arranged%20in%20a%20fan%20on%20a%20crisp%20white%20background%2C%20bright%20airy%20daylight%2C%20cheerful%20yet%20refined%20e-commerce%20styling%20with%20soft%20shadows%20and%20clean%20geometric%20spacing&width=400&height=300&seq=cat-tshirts&orientation=landscape&nocache=true',
  },
  {
    id: 'jackets',
    name: 'Jackets',
    namePt: 'Jaquetas',
    nameDe: 'Jacken',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=A%20tailored%20camel%20wool%20overcoat%20hanging%20on%20a%20natural%20wooden%20hanger%20against%20a%20warm%20ivory%20wall%2C%20soft%20golden%20afternoon%20light%20casting%20a%20subtle%20shadow%2C%20sophisticated%20menswear%20lookbook%20photography%20with%20a%20refined%20minimalist%20composition%20and%20premium%20fabric%20texture&width=400&height=300&seq=cat-jackets&orientation=landscape&nocache=true',
  },
  {
    id: 'pants',
    name: 'Pants / Shorts',
    namePt: 'Calças / Shorts',
    nameDe: 'Hosen / Shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=Neatly%20folded%20raw%20indigo%20denim%20jeans%20and%20a%20pair%20of%20stone%20chino%20shorts%20stacked%20on%20a%20light%20warm%20gray%20concrete%20surface%2C%20soft%20diffused%20studio%20lighting%2C%20modern%20menswear%20e-commerce%20flat%20lay%20with%20crisp%20fabric%20folds%20and%20a%20clean%20minimal%20aesthetic&width=400&height=300&seq=cat-pants&orientation=landscape&nocache=true',
  },
  {
    id: 'headwear',
    name: 'Headwear',
    namePt: 'Chapéus',
    nameDe: 'Kopfbedeckungen',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=Three%20stylish%20baseball%20caps%20in%20forest%20green%2C%20cream%20and%20burnt%20orange%20arranged%20in%20a%20row%20on%20a%20soft%20sage%20green%20studio%20backdrop%2C%20bright%20even%20lighting%2C%20contemporary%20streetwear%20accessory%20photography%20with%20a%20playful%20yet%20polished%20minimalist%20composition&width=400&height=300&seq=cat-headwear&orientation=landscape&nocache=true',
  },
  {
    id: 'sets',
    name: 'Sets',
    namePt: 'Conjuntos',
    nameDe: 'Sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=A%20coordinated%20athleisure%20tracksuit%20set%20in%20soft%20heather%20gray%20folded%20together%20on%20a%20light%20beige%20linen%20surface%20with%20a%20small%20potted%20plant%20nearby%2C%20warm%20natural%20morning%20light%2C%20relaxed%20lifestyle%20product%20photography%20with%20a%20cozy%20premium%20minimal%20feel&width=400&height=300&seq=cat-sets&orientation=landscape&nocache=true',
  },
  {
    id: 'underwear',
    name: 'Underwear / Underpants',
    namePt: 'Roupa Íntima / Cuecas',
    nameDe: 'Unterwäsche / Unterhosen',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=Soft%20cotton%20boxer%20briefs%20in%20muted%20navy%2C%20charcoal%20and%20off-white%20folded%20into%20neat%20squares%20on%20a%20gentle%20blush%20pink%20background%2C%20soft%20diffused%20daylight%2C%20tasteful%20minimalist%20essentials%20photography%20with%20delicate%20shadows%20and%20a%20clean%20premium%20feel&width=400&height=300&seq=cat-underwear&orientation=landscape&nocache=true',
  },
  {
    id: 'jersey',
    name: 'Jersey',
    namePt: 'Jersey',
    nameDe: 'Trikot',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=A%20professional%20football%20soccer%20jersey%20in%20vivid%20emerald%20green%20and%20white%20laid%20flat%20on%20a%20light%20stone%20background%2C%20crisp%20studio%20lighting%20emphasizing%20breathable%20mesh%20texture%2C%20dynamic%20sports%20apparel%20catalog%20photography%20with%20a%20clean%20energetic%20minimal%20composition&width=400&height=300&seq=cat-jersey&orientation=landscape&nocache=true',
  },
  {
    id: 'accessories',
    name: 'Accessories',
    namePt: 'Acessórios',
    nameDe: 'Accessoires',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=A%20minimalist%20wristwatch%20and%20a%20pair%20of%20classic%20sunglasses%20arranged%20on%20a%20textured%20beige%20stone%20pedestal%2C%20soft%20warm%20lighting%20with%20gentle%20reflections%2C%20elegant%20luxury%20accessory%20still%20life%20photography%20with%20generous%20negative%20space%20and%20a%20refined%20neutral%20palette&width=400&height=300&seq=cat-accessories&orientation=landscape&nocache=true',
  },
  {
    id: 'bags',
    name: 'Bags',
    namePt: 'Bolsas',
    nameDe: 'Taschen',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=A%20structured%20cognac%20brown%20leather%20tote%20bag%20standing%20upright%20on%20a%20warm%20oak%20wood%20surface%2C%20rich%20golden%20hour%20side%20lighting%20revealing%20premium%20grain%2C%20sophisticated%20fashion%20accessory%20photography%20with%20a%20clean%20warm%20minimalist%20composition&width=400&height=300&seq=cat-bags&orientation=landscape&nocache=true',
  },
  {
    id: 'belts',
    name: 'Belts',
    namePt: 'Cintos',
    nameDe: 'Gürtel',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=A%20coiled%20dark%20brown%20and%20a%20tan%20leather%20belt%20with%20brushed%20metal%20buckles%20arranged%20elegantly%20on%20a%20slate%20gray%20stone%20background%2C%20soft%20directional%20lighting%20emphasizing%20stitching%20detail%2C%20refined%20menswear%20accessory%20still%20life%20with%20a%20sophisticated%20minimalist%20composition&width=400&height=300&seq=cat-belts&orientation=landscape&nocache=true',
  },
  {
    id: 'perfumes',
    name: 'Perfumes',
    namePt: 'Perfumes',
    nameDe: 'Parfums',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=An%20elegant%20amber%20glass%20perfume%20bottle%20with%20a%20minimal%20gold%20cap%20on%20a%20soft%20champagne%20silk%20background%2C%20luxurious%20soft%20backlighting%20creating%20a%20warm%20glow%2C%20high-end%20fragrance%20product%20photography%20with%20a%20refined%20glamorous%20yet%20clean%20minimalist%20aesthetic&width=400&height=300&seq=cat-perfumes&orientation=landscape&nocache=true',
  },
  {
    id: 'other',
    name: 'Other Stuff',
    namePt: 'Outros',
    nameDe: 'Sonstiges',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=A%20curated%20collection%20of%20lifestyle%20goods%20including%20a%20notebook%2C%20a%20ceramic%20mug%20and%20a%20small%20leather%20pouch%20arranged%20on%20a%20warm%20cream%20surface%2C%20soft%20natural%20light%2C%20cozy%20editorial%20flat%20lay%20photography%20with%20a%20harmonious%20neutral%20palette%20and%20gentle%20shadows&width=400&height=300&seq=cat-other&orientation=landscape&nocache=true',
  },
];

export type Category = (typeof categories)[number];